import React from 'react';
import PropTypes from 'prop-types';


import { AggregatorTableDetails } from '../aggregatorTableDetails/aggregatorTableDetails';

const { FormattedText } = require('core/i18n').i18n;

const TRANSLATION_KEY_PREFIX = 'aggregatorDepositBoxDetailsHeader'

class AggregatorDepositDetails extends React.PureComponent {

    buildTableValues = () => {
        const { startDate, endDate, tax, balance } = this.props;

        return [{
            type: 'date',
            value: startDate
        },{
            type: 'date',
            value: endDate
        },{
            type: 'text',
            value: `${Number(tax)}%`
        },{
            type: 'amount',
            value: balance
        }];
    };

    buildTableHeader = () => {
        return [
            <FormattedText key={`${TRANSLATION_KEY_PREFIX}-startDate`} value={`${TRANSLATION_KEY_PREFIX}-startDate`}/>,
            <FormattedText key={`${TRANSLATION_KEY_PREFIX}-endDate`} value={`${TRANSLATION_KEY_PREFIX}-endDate`}/>,
            <FormattedText key={`${TRANSLATION_KEY_PREFIX}-//`} value={`${TRANSLATION_KEY_PREFIX}-//`}/>,
            <FormattedText key={`${TRANSLATION_KEY_PREFIX}-balance`} value={`${TRANSLATION_KEY_PREFIX}-balance`}/>
        ];
    };

    render(){
        const header = this.buildTableHeader();
        const values = this.buildTableValues();

        return (
            <AggregatorTableDetails
                values={[values]}
                header={header}
            />
        );
    }
}

AggregatorDepositDetails.propTypes = {
    startDate: PropTypes.number,
    endDate: PropTypes.number,
    tax: PropTypes.string,
    balance: PropTypes.object
};

export { AggregatorDepositDetails };